import { differenceInHours, differenceInMinutes, format, isToday, isYesterday } from 'date-fns'
import { NEXT_PUBLIC_CF_URL } from '@web/utils/env'

export function formatRelativeDate(date: Date): string {
  const now = new Date()

  const minutesDiff = differenceInMinutes(now, date)
  if (minutesDiff < 1) {
    return 'just now'
  } else if (minutesDiff < 60) {
    return `${minutesDiff} mins ago`
  }

  const hoursDiff = differenceInHours(now, date)
  if (isToday(date)) {
    return `${hoursDiff} hours ago`
  } else if (isYesterday(date)) {
    return 'Yesterday'
  }

  return format(date, 'dd/MM/yyyy')
}

export const sanitizeText = (title: string) => title.replace("\\'", "'")

export const prodCategoriesMap = new Map([
  ['pngs', { name: 'PNG', slug: 'png' }],
  ['cartoons', { name: 'Cartoons', slug: 'cartoons' }],
  ['sketches', { name: 'Sketches', slug: 'sketches' }],
  ['coloring-pages', { name: 'Coloring Pages', slug: 'coloring-pages' }],
  ['backgrounds', { name: 'Backgrounds', slug: 'backgrounds' }],
  ['kawaii', { name: 'Kawaii', slug: 'kawaii' }],
  ['stockphotos', { name: 'Stock Photos', slug: 'stockphotos' }],
  ['mockups', { name: 'Mockups', slug: 'mockups' }],
  ['quotes', { name: 'Quotes', slug: 'quotes' }],
  ['borders-and-corners', { name: 'Borders & Corners', slug: 'borders-and-corners' }],
  ['frames', { name: 'Frames', slug: 'frames' }],
  ['patterns', { name: 'Patterns', slug: 'patterns' }],
])

export const getProductUrl = ({
  authorId,
  productSlug,
}: {
  authorId: string
  productSlug: string
}) => {
  const matchingCategory = prodCategoriesMap.get(authorId)
  const pathFragment = matchingCategory ? 'prod' : 'product'
  const productUrl = `${NEXT_PUBLIC_CF_URL}/${pathFragment}/${productSlug}/`
  return productUrl
}
